module.exports = __webpack_public_path__ + "r-v3/img/more_white.68161edf.svg";